import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Global } from '../../shared/global';
import { getQuery } from '../../shared/utils';
import { IVermittlerResult } from '../models/vermittlerresult';

@Injectable({
  providedIn: 'root'
})
export class VermittlerService {

  vermittlerResult: IVermittlerResult;

  constructor(private http: HttpClient) { }

  loadVermittlerResult(): Promise<void> {
    return new Promise((resolve, reject) => {
      // Executed before the application is bootstrapped, router is not initialized yet
      const params = new URL(window.location.href).searchParams;
      const query = params.get('q') ?? getQuery();
      if (query) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: headers };
        this.http.post<IVermittlerResult>(Global.BASE_VERMITTLER_ENDPOINT + `getvermittlerresult` + (query ? `?q=${query}` : ''), null, options).subscribe(vermittlerResult => {
          this.vermittlerResult = vermittlerResult;
          resolve();
        },
          (err: HttpErrorResponse) => {
            reject(err);
          });
      } else {
        resolve();
      }
    });
  }
}
